import { Input, Checkbox, CheckboxGroup, ScrollShadow } from '@nextui-org/react'
import { useState } from 'react'
import countries from 'src/data/country_table.json'
export default function CountryPicker({ selectedValue, onSelect }) {
  const [searchValue, setSearchValue] = useState<string>('')
  return (
    <div className="flex flex-col gap-2">
      <Input
        placeholder="e.g Germany"
        onChange={(e) => setSearchValue(e.target.value)}
        variant="bordered"
        label="Country name"
        value={searchValue}
      />
      <ScrollShadow className="max-h-[350px] pt-2 pb-2">
        <CheckboxGroup onChange={(selectedKeys) => onSelect(selectedKeys)} value={selectedValue}>
          {countries
            .filter((item) => item.label.toLowerCase().startsWith(searchValue.toLowerCase()))
            .map((country: any) => (
              <Checkbox  key={country.code} value={country.code} classNames={{ label: 'text-sm' }}>
                {country.label}
              </Checkbox>
            ))}
        </CheckboxGroup>
      </ScrollShadow>
    </div>
  )
}
